module.exports = __webpack_public_path__ + "static/img/bip10B1jpg.ac34fda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bip10B1jpg.jpg
// module id = q6uT
// module chunks = 73